import { FC, ReactNode } from "react";
import { BaseContainer } from "./Base.styles";

interface BaseProps {
  children: ReactNode;
  fullWidth?: boolean;
}

const Base: FC<BaseProps> = ({ children, fullWidth = false }) => {
  return <BaseContainer $fullWidth={fullWidth}>{children}</BaseContainer>;
};

export default Base;
